import { copyCollectionLinkToClipboard } from "@/actions/copyCollectionLinkToClipboard";
import { copyNoteLinkToClipboard } from "@/actions/copyNoteLinkToClipboard";
import { copyUrlToClipboard } from "@/actions/copyUrlToClipboard";
import { deleteCollectionPermanently } from "@/actions/deleteCollectionPermanently";
import { deleteNotesPermanently } from "@/actions/deleteNotesPermanently";
import { moveNotesToTrash } from "@/actions/moveNoteToTrash";
import { restoreNotesFromTrash } from "@/actions/restoreNotesFromTrash";
import { removeNoteFromCollection } from "@/actions/removeNoteFromCollection";
import { addNotesToCollection } from "@/actions/addNotesToCollection";
import { removeNotesFromCollection } from "@/actions/removeNotesFromCollection";
import { openCollectionInNewTab } from "@/actions/openCollectionInNewTab";
import { openNoteInNewTab } from "@/actions/openNoteInNewTab";
import { openSearchInNewTab } from "@/actions/openSearchInNewTab";
import { createCollection } from "@/actions/createCollection";
import { copyTemplateLinkToClipboard } from "@/actions/copyTemplateLinkToClipboard";
import { autoOrganizeNotes } from "@/actions/autoOrganizeNotes";
import { startChatWithEntities } from "@/actions/startChatWithEntities";
import { deleteNoteSource } from "@/actions/deleteNoteSource";
import { sendPendingChatMessage } from "@/actions/sendPendingChatMessage";
import { copyNoteTranscript, copyRecordingTranscript } from "@/actions/copyTranscript";
import { downloadArtifactAudio, downloadRecordingAudio } from "@/actions/download-audio";

export const actions = {
  addNotesToCollection,
  autoOrganizeNotes,
  copyUrlToClipboard,
  copyCollectionLinkToClipboard,
  copyNoteLinkToClipboard,
  copyTemplateLinkToClipboard,
  createCollection,
  deleteCollectionPermanently,
  deleteNotesPermanently,
  moveNotesToTrash,
  restoreNotesFromTrash,
  removeNoteFromCollection,
  removeNotesFromCollection,
  openCollectionInNewTab,
  openNoteInNewTab,
  openSearchInNewTab,
  copyRecordingTranscript,
  copyNoteTranscript,
  downloadArtifactAudio,
  downloadRecordingAudio,
  deleteNoteSource,
  startChatWithEntities,
  sendPendingChatMessage,
} as const;
